import type { ApStatus } from '../lib/piClient.js';
import type { PiHealth } from '../hooks/usePiBackend.js';

interface Props {
  health: PiHealth;
  version: string | null;
  apStatus: ApStatus | null;
  baseUrl: string;
  lastError: string | null;
}

export function PiStatusIndicator({ health, version, apStatus, baseUrl, lastError }: Props) {
  const dotClass = health === 'ok' ? 'ok' : health === 'down' ? 'down' : '';
  return (
    <div className="row" aria-label="Pi backend status">
      <span>
        <span className={`status-dot ${dotClass}`} />
        <strong>Pi:</strong>{' '}
        {health === 'ok'
          ? `online (v${version ?? '?'})`
          : health === 'down'
            ? 'unreachable'
            : 'unknown'}
      </span>
      <span className="muted">{baseUrl}</span>
      <span>
        <strong>AP:</strong>{' '}
        {apStatus === null
          ? '—'
          : apStatus.status === 'active'
            ? `${apStatus.ssid} · ${apStatus.config.country} ch${apStatus.config.channel}`
            : 'stopped'}
      </span>
      {lastError && health !== 'ok' && (
        <span className="muted" title={lastError}>
          ({truncate(lastError, 60)})
        </span>
      )}
    </div>
  );
}

function truncate(s: string, n: number): string {
  return s.length <= n ? s : `${s.slice(0, n - 1)}…`;
}
